export const getComparisonPlanLabel = (planId, {
  hasMultiplePlans,
  customDiscount360 = 20,
  customDiscount180 = 0,
  t,
}) => {
  if (planId === '360-days') {
    if (!hasMultiplePlans || customDiscount360 === 0) {
      return t('subscription.360DaysNoBonus', '360 days');
    }
    return t('subscription.360DaysCustom', '360 days (bonus {{discount}}%)', { discount: customDiscount360 });
  }

  if (planId === '180-days') {
    if (customDiscount180 === 0) {
      return t('subscription.180Days', '180 days');
    }
    return t('subscription.180DaysCustom', '180 days (bonus {{discount}}%)', { discount: customDiscount180 });
  }

  const labels = {
    '360-days-split': t('subscription.360DaysSplit', '360 days (installment)'),
    '90-days': t('subscription.90Days', '90 days'),
    '12-month-contract': t('subscription.12MonthContract', '12-monthly contract'),
  };

  return labels[planId] || planId;
};

export const getComparisonPlanSavings = (plan, hasMultiplePlans) => {
  if (!hasMultiplePlans || !plan) return 0;
  return plan.savings || plan.discountAmount || plan.discount_amount || 0;
};
